import { ColTypeDef, ICellRendererParams } from "ag-grid-community";
import React from "react";

import { Text } from "../../../atoms/Text";

// Custom cell renderer for text columns with line clamping
export const TextCellRenderer = (params: ICellRendererParams) => {
	return (
		<div className="flex size-full min-h-0 items-center justify-start">
			<div className="py-line-clamp-1">
				<Text size="paragraph-3" weight="regular">
					{params.valueFormatted ?? params.value ?? ""}
				</Text>
			</div>
		</div>
	);
};

const TextCol: ColTypeDef = {
	cellRenderer: TextCellRenderer,
};

export default TextCol;
